import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import styled from 'styled-components';
import Title from 'components/blog/title';
import Container from 'components/container';
import PublicLayout from 'components/layouts/Public';
import { GOOGLE_DRIVE_RESUME_URL } from 'constants/urls';

// TODO: move this to just one component for all pages
const FullWidthDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: left;
  align-items: left;
`;

const ResumePdfPage = () => {
  useEffect(() => {
    // Track the redirect event
    TagManager.dataLayer({
      dataLayer: {
        event: 'resume_redirect',
        page: 'resume_pdf',
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const router = useRouter();

  useEffect(() => {
    router.push(GOOGLE_DRIVE_RESUME_URL);
  }, [router]);

  return (
    <PublicLayout title="Resume">
      <Container centerContent py="20px" pylg="20px">
        <FullWidthDiv>
          <Title margin="15px 0 15px 40px">You&apos;ll be redirected to my resume.</Title>
        </FullWidthDiv>
      </Container>
    </PublicLayout>
  );
};

export default ResumePdfPage;
